import { gql } from "@apollo/client";

const CREATE_SPORTS = gql`
  mutation createSport(
    $title: String!
    $abbreviation: String
    $resourceTitle: String
    $icon: Upload
    $enableDiscipline: Boolean
    $enableCourts: Boolean
    $enableStages: Boolean
    $displayDraws: Boolean
    $displayGroups: Boolean
    $displayLiveStandings: Boolean
    $displayOrderPlay: Boolean
    $displayListResults: Boolean
    $displayPendingResults: Boolean
    $displayTournamentResults: Boolean
    $isEnablePairingStandings: Boolean
    $isEnableRounds: Boolean
    $textBox: String
    $isDisplayAthleteChessTitle: Boolean
    $isDisplaySeeds: Boolean
    $isDisplaySegments: Boolean
    $footballLineupEnabled: Boolean
    $footballAdvancedMatchDetailsEnabled: Boolean
    $footballGroupStandingsEnabled: Boolean
    $footballLiveStandingsEnabled: Boolean
  ) {
    createSport(
      createSportInput: {
        title: $title
        icon: $icon
        abbreviation: $abbreviation
        resourceTitle: $resourceTitle
        enableDiscipline: $enableDiscipline
        enableCourts: $enableCourts
        enableStages: $enableStages
        displayDraws: $displayDraws
        displayGroups: $displayGroups
        displayLiveStandings: $displayLiveStandings
        displayOrderPlay: $displayOrderPlay
        displayListResults: $displayListResults
        displayPendingResults: $displayPendingResults
        displayTournamentResults: $displayTournamentResults
        isEnablePairingStandings: $isEnablePairingStandings
        isEnableRounds: $isEnableRounds
        textBox: $textBox
        isDisplayAthleteChessTitle: $isDisplayAthleteChessTitle
        isDisplaySeeds: $isDisplaySeeds
        isDisplaySegments: $isDisplaySegments
        footballLineupEnabled: $footballLineupEnabled
        footballAdvancedMatchDetailsEnabled: $footballAdvancedMatchDetailsEnabled
        footballGroupStandingsEnabled: $footballGroupStandingsEnabled
        footballLiveStandingsEnabled: $footballLiveStandingsEnabled
      }
    ) {
      title
    }
  }
`;

export default CREATE_SPORTS;
